import {executeQuery} from "@/main";
import salutations from 'raw-loader!./graphql/query/salutations.graphqls';
import genders from 'raw-loader!./graphql/query/genders.graphqls';
import countries from 'raw-loader!./graphql/query/countries.graphqls';
import professions from 'raw-loader!./graphql/query/professions.graphqls';
import primaryActivities from 'raw-loader!./graphql/query/primaryActivities.graphqls';
import roles from 'raw-loader!./graphql/query/contactRoles.graphqls';
import mediums from 'raw-loader!./graphql/query/mediums.graphqls';
import accountsByCountry from 'raw-loader!./graphql/query/accountsByCountry.graphqls';
import publicationLanguages from 'raw-loader!./graphql/query/publicationLanguages.graphqls';
import publicationTargets from 'raw-loader!./graphql/query/publicationTargets.graphqls';
import publicationTypes from 'raw-loader!./graphql/query/publicationTypes.graphqls';
import editorialInterests from 'raw-loader!./graphql/query/editorialInterests.graphqls';
import focusAreas from 'raw-loader!./graphql/query/focusAreas.graphqls';
import attendanceTypes from 'raw-loader!./graphql/query/attendanceTypes.graphqls';
import meetings from 'raw-loader!./graphql/query/meetings.graphqls';
import howToContactTypes from 'raw-loader!./graphql/query/howToContactTypes.graphqls';
import validateEmail from 'raw-loader!./graphql/query/validateEmail.graphqls';
import interviewRequest from 'raw-loader!./graphql/mutation/interviewRequest.graphqls';

export default class AppService {
    salutations(){
        return executeQuery(null, salutations)
    }
    genders(){
        return executeQuery(null, genders)
    }
    countries(){
        return executeQuery(null, countries)
    }
    professions(){
        return executeQuery(null, professions)
    }
    primaryActivities(){
        return executeQuery(null, primaryActivities)
    }
    roles(){
        return executeQuery(null, roles)
    }
    mediums(){
        return executeQuery(null, mediums)
    }
    howToContactTypes(){
        return executeQuery(null, howToContactTypes)
    }
    accountsByCountry(country){
        return executeQuery(null, accountsByCountry,{country})
    }
    publicationLanguages(){
        return executeQuery(null, publicationLanguages)
    }
    publicationTargets(){
        return executeQuery(null, publicationTargets)
    }
    publicationTypes(){
        return executeQuery(null, publicationTypes)
    }
    editorialInterests(){
        return executeQuery(null, editorialInterests)
    }
    focusAreas(){
        return executeQuery(null, focusAreas)
    }
    attendanceTypes(meetingCode){
        return executeQuery(null, attendanceTypes,{meetingCode})
    }
    meetings(){
        return executeQuery(null, meetings)
    }
    validateEmail(email){
        return executeQuery(null, validateEmail,{email})
    }
    interviewRequest(request) {
        return executeQuery(null, interviewRequest, {request})
    }
}
